@if (visible) {
  <div class="modal-overlay" (click)="onOverlayClick($event)">
    <div
      class="result-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      data-testid="subscription-result-modal"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <div class="result-modal__header">
        <h2 class="result-modal__header-title">{{ header }}</h2>
        <button type="button" class="result-modal__close" aria-label="Close" (click)="close.emit()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <div class="result-modal__body" role="status">
        <img
          class="result-modal__icon"
          src="assets/images/package/circle-check-filled.svg"
          alt=""
          aria-hidden="true"
        />
        <h3 class="result-modal__title" [id]="titleId">{{ title }}</h3>
        <p class="result-modal__message">{{ message }}</p>
      </div>
    </div>
  </div>
}
